
// SVG Icon: accordion-close
export default { id: "terriajs-accordion-close" };
export const id = "terriajs-accordion-close";
export const name = "accordion-close";
